// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import 'rc-slider/assets/index.css'
import Slider from 'rc-slider'
import Switch from '@material-ui/core/Switch'
import React from 'react'
import PropStyles from 'catena/er2_styles/layer_properties'
import Color from './color'
import SymbolProperties from './symbol_properties'
import { getLayerType } from '../utils'
import type { MapType } from '../reducers/map'
import type { UserLayerType } from '../reducers/mapsources'

function TabContainer(props: { children: [] }) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    )
}

type PropTypes = {
    layerProps: UserLayerType,
    map: MapType,
    onChangeProps: Function,
    onClose: Function,
    // Update the layer with the current classification list
    onChangeClassifications: Function,
    // Retrieve classification list from the server
    getLayerClassifications: Function,
    pos: {
        right: number,
        top: number,
    },
    theme: PropStyles,
}

const Handle = Slider.Handle

const handleSliderChange = (props) => {
    const { dragging, ...restProps } = props
    return (
        <Handle {...restProps} />
    )
}

class LayerProperties extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.height = 550
        this.state = {
            minColor: '#FF0000',
            maxColor: '#0000FF',
            classifyType: 'Single Symbol',
            classifyField: undefined,
            fontSize: 6,
            labelBorderWidth: 1,
            labelTextColor: '#000',
            labelBackgroundColor: '#fff',
            labelBackgroundVisible: true,
            labelBold: false,
            labelBorderColor: '#fff',
            labelField: 'name',
            labelFont: 'Roboto Condensed',
            labelItalic: false,
            labelScaleMin: '',
            labelScaleMax: '',
            labelSize: 12,
            nclass: 5,
            randomColors: false,
            identifiable: false,
            author: '',
            scaleMin: '',
            scaleMax: '',
            tags: [],
            ...props.layerProps,
            local: {
                classifyTypeSaved: (props.layerProps.classifyType === undefined) ? 'Single Symbol' : props.layerProps.classifyType,
                classifyFieldSaved: props.layerProps.classifyField,
                editSym: new Set(),
                lastSymClick: -1,
                itab: 0,
                newTag: '',
            },
        }

        Object.entries(props.layerProps).forEach(([k, val]) => {
            if (val === 'None') {
                this.state[k] = ''
            }
        })

        // Initialize user metadata
        if (!this.state.userMetadata) {
            this.state.userMetadata = {}
        }
        // Convert dict to list for easier editing
        this.state.userMetadataList = []
        Object.entries(this.state.userMetadata).forEach(([key, value], i) => {
            // Maintain a static key field so the cell being edited won't jump
            this.state.userMetadataList.push([`key${i}`, key, value])
        })
        this.state.userMetadataList.push([`key${this.state.userMetadataList.length}`, '', ''])
    }

    onChangeProps = () => {
        const newlayerprops = {}
        Object.entries(this.state).forEach((entry) => {
            const [k, v] = entry
            if (k !== 'local' && v !== this.props.layerProps[k]) {
                newlayerprops[k] = v
            }
        })
        // Convert metadata
        if (this.state.userMetadataList) {
            newlayerprops.userMetadata = this.state.userMetadataList.reduce((map, [_, k, v]) => {
                if (k) {
                    map[k] = v
                }
                return map
            }, {})
            delete newlayerprops.userMetadataList
        }

        this.props.onChangeProps(newlayerprops)
    }

    closeSymHTML() {
        this.setState({ local: { ...this.state.local, editSym: new Set() } })
    }

    openSymHTML(i) {
        const newEditSym = new Set([i])
        this.setState({ local: { ...this.state.local, editSym: newEditSym } })
    }

    deleteTag(i) {
        const tags = [...this.state.tags]
        tags.splice(i, 1)
        this.setState({ tags })
    }

    hasTag(tag) {
        return this.state.tags.indexOf(tag) >= 0
    }

    addTag(label) {
        let tags = this.state.tags
        if (!this.hasTag(label) && label) {
            tags = [...this.state.tags, label]
            tags.sort()
            this.setState({ tags })
        }
    }

    handleTagInput(input) {
        if (input.split(' ').length > 1) {
            let tagWord = input.split(' ')[0].toLowerCase()
            tagWord = tagWord.replace(/\W/g, '')
            this.addTag(tagWord)
            this.setState({ local: { ...this.state.local, newTag: '' } })
        } else {
            this.setState({ local: { ...this.state.local, newTag: input.replace(/\W/g, '') } })
        }
    }

    updateSavedClassifications() {
        this.setState({
            local: {
                ...this.state.local,
                classifyTypeSaved: this.state.classifyType,
                classifyFieldSaved: this.state.classifyField,
            },
        })
    }

    updateMetadata = key => (e) => {
        this.setState({ [key]: e.target.value })
    }

    updateUserMetadataKey = ikey => (e) => {
        const newKey = e.target.value
        const userMetadataList = [...this.state.userMetadataList]
        userMetadataList[ikey][1] = newKey
        this.setState({ userMetadataList })
    }

    updateUserMetadataValue = ivalue => (e) => {
        const newValue = e.target.value
        const userMetadataList = [...this.state.userMetadataList]
        userMetadataList[ivalue][2] = newValue
        this.setState({ userMetadataList })
    }

    checkAddUserMetadataValue = ivalue => (e) => {
        if (e.key === 'Enter') {
            this.updateUserMetadataValue(ivalue)(e)
            this.checkUserMetadataList()
        }
    }

    checkUserMetadataList = () => {
        const userMetadataList = [...this.state.userMetadataList]
        const lastKV = userMetadataList[userMetadataList.length - 1]
        if (lastKV[1] !== '') {
            userMetadataList.push([`key${userMetadataList.length}`, '', ''])
            this.setState({ userMetadataList })
        }
    }

    deleteUserMetadata = ivalue => () => {
        const userMetadataList = [...this.state.userMetadataList.slice(0, ivalue), ...this.state.userMetadataList.slice(ivalue + 1)]
        this.setState({ userMetadataList })
    }

    renderMetadata() {
        const { theme } = this.props
        const userMetadataList = this.state.userMetadataList
        const tags = this.state.tags.map((data, i) => (
            <Chip
                key={data}
                label={data}
                onDelete={() => this.deleteTag(i)}
                className={theme.tag}
            />
        ))

        // Standard metadata
        const metadataKeys = [
            ['Author', this.state.author, 'author'],
            ['Feature Type', this.props.layerProps.schema.geometry],
            ['Feature Count', this.props.layerProps.row_count],
            ['Projection', this.props.layerProps.layer_type === 'RASTER' ?
                this.props.layerProps.proj4 : this.props.layerProps.crs.init],
            ['File Path', this.props.layerProps.filepath],
            ['Name', this.props.layerProps.name],
        ]

        return (
            <TabContainer>
                <div className={theme.metadataContainer}>
                    <div>
                        <span className={theme.paramLabel}>
                            Tags
                        </span>
                        <TextField
                            onChange={(e) => {
                                this.handleTagInput(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13 && e.shiftKey === false) {
                                    e.preventDefault()
                                    this.handleTagInput(`${this.state.local.newTag} `)
                                }
                            }}
                            type="text"
                            value={this.state.local.newTag}
                        />
                    </div>
                    <div>
                        <div className={theme.tagBox}>
                            {tags}
                        </div>
                    </div>

                    {metadataKeys.map(([label, value, key]) => (
                        <div key={label}>
                            <span className={theme.paramLabel}>
                                {label}
                            </span>
                            {key ? (
                                <TextField
                                    defaultValue={value}
                                    onChange={this.updateMetadata(key)}
                                    type="text"
                                />
                            ) : (
                                <span>
                                    {value}
                                </span>
                            )}
                        </div>
                    ))}
                    <div><Typography>Addtional Metadata</Typography></div>
                    <div className={theme.userMetadata}>
                        {userMetadataList.map(([reactKey, key, value], i) => (
                            <div key={reactKey}>
                                <span className={theme.paramLabel}>
                                    <Input
                                        onBlur={this.updateUserMetadataKey(i)}
                                        onChange={this.updateUserMetadataKey(i)}
                                        placeholder={'key'}
                                        value={key || ''}
                                    />
                                </span>
                                <span className={theme.paramValue}>
                                    <Input
                                        onBlur={this.checkUserMetadataList}
                                        onChange={this.updateUserMetadataValue(i)}
                                        onKeyDown={this.checkAddUserMetadataValue(i)}
                                        placeholder={'value'}
                                        value={value || ''}
                                    />
                                </span>
                                {key && (
                                    <Button
                                        onClick={this.deleteUserMetadata(i)}
                                    ><span className={'fa fa-trash'} /></Button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </TabContainer>
        )
    }

    onCheckClick(e, i) {
        e.preventDefault()
        const newEditSym = new Set(this.state.local.editSym)
        if (e.shiftKey && this.state.local.lastSymClick >= 0) {
            const min = (i < this.state.local.lastSymClick) ? i : this.state.local.lastSymClick
            const max = (i < this.state.local.lastSymClick) ? this.state.local.lastSymClick : i
            if (newEditSym.has(i)){
                for(let j = min ;j <= max ;j++){
                    newEditSym.delete(j)
                }
            } else {
                for(let j = min ;j <= max ;j++){
                    newEditSym.add(j)
                }
            }
        } else {
            if (newEditSym.has(i)) {
                newEditSym.delete(i)
            } else {
                newEditSym.add(i)
            }
        }
        this.setState({ local: { ...this.state.local, editSym: newEditSym, lastSymClick: i } })
    }

    render() {
        const itab = this.state.local.itab
        const { theme } = this.props

        const extents = this.props.layerProps.bbox_4326.map(f => f.toFixed(3))

        const handleChange = (event, value) => {
            this.setState({ local: { ...this.state.local, itab: value } })
        }

        const changeSlider = (prop, value) => {
            this.setState({ [prop]: value })
        }
        const updateClassifications = () => {
            this.updateSavedClassifications()
            const success = (classifications) => {
                this.setState({ classifications })
            }
            this.props.getLayerClassifications(
                this.state.classifyField,
                this.state.classifyType,
                {
                    nclass: this.state.nclass,
                    min_color: this.state.minColor,
                    max_color: this.state.maxColor,
                    random_colors: this.state.randomColors,
                    success,
                })
        }

        let symHTML
        if (this.state.local.editSym.size === 1) {
            const index = this.state.local.editSym.values().next().value

            const updateSymbol = (newprops) => {
                const classifications = [...this.state.classifications]
                classifications[index] = { ...classifications[index], ...newprops }
                this.setState({ ...this.state, classifications })
            }
            let width = 0
            if (this.ref !== undefined) {
                width = this.ref.getBoundingClientRect().width
            }
            const symbolData = {}
            Object.assign(symbolData, this.state.classifications[index])
            if (symbolData.opacity === undefined) {
                symbolData.opacity = 100
            }
            if (symbolData.size === undefined) {
                symbolData.size = 20
            }
            if (symbolData.hatchsize === undefined) {
                symbolData.hatchsize = 0
            }
            if (symbolData.bordersize === undefined) {
                symbolData.bordersize = 0
            }
            if (symbolData.bordercolor === undefined) {
                symbolData.bordercolor = '#22194D'
            }
            if (symbolData.symbolType === undefined) {
                symbolData.symbolType = 'Solid'
            }
            if (symbolData.transparent === undefined) {
                symbolData.transparent = false
            }
            symHTML = (
                <SymbolProperties
                    layerProps={this.props.layerProps}
                    map={this.props.map}
                    onUpdate={updateSymbol}
                    pos={{ right: width }}
                    onClose={() => this.closeSymHTML()}
                    symbol={symbolData}
                />
            )
        } else if (this.state.local.editSym.size > 1) {
            const iter = this.state.local.editSym.values()
            let index = iter.next().value

            const updateSymbol = (newprops) => {
                const classifications = [...this.state.classifications]

                this.state.local.editSym.forEach((i) => {
                    classifications[i] = { ...classifications[i], ...newprops }
                })

                this.setState({ ...this.state, classifications })
            }

            const symbolData = {}
            Object.assign(symbolData, this.state.classifications[index])

            index = iter.next().value
            while (index !== undefined) {
                Object.keys(symbolData).forEach((key) => {
                    if (key !== 'expression' && key !== 'label' && symbolData[key] !== this.state.classifications[index][key]) {
                        symbolData[key] = 'varied'
                    }
                })
                index = iter.next().value
            }
            if (symbolData.opacity === undefined) {
                symbolData.opacity = 100
            }
            if (symbolData.size === undefined) {
                symbolData.size = 20
            }
            if (symbolData.hatchsize === undefined) {
                symbolData.hatchsize = 0
            }
            if (symbolData.bordersize === undefined) {
                symbolData.bordersize = 0
            }
            if (symbolData.bordercolor === undefined) {
                symbolData.bordercolor = '#22194D'
            }
            if (symbolData.symbolType === undefined) {
                symbolData.symbolType = 'Solid'
            }
            if (symbolData.transparent === undefined) {
                symbolData.transparent = false
            }
            Object.keys(symbolData).forEach((key) => {
                if (symbolData[key] === 'varied') {
                    symbolData[key] = undefined
                }
            })
            index = iter.next().value

            let width = 0
            if (this.ref !== undefined) {
                width = this.ref.getBoundingClientRect().width
            }

            symHTML = (
                <SymbolProperties
                    layerProps={this.props.layerProps}
                    map={this.props.map}
                    onUpdate={updateSymbol}
                    pos={{ right: width }}
                    onClose={() => this.closeSymHTML()}
                    symbol={symbolData}
                />
            )
        }

        const fonts = [
            'Arial',
            'Arial Bold',
            'Arial Italic',
            'Arial Bold Italic',
            'Roboto',
            'Roboto Bold',
            'Roboto Bold Italic',
            'Roboto Italic',
            'Roboto Light',
            'Roboto Medium',
            'Roboto Thin',
            'Roboto Condensed',
            'Roboto Condensed Bold',
            'Roboto Condensed Bold Italic',
            'Roboto Condensed Italic',
            'Roboto Condensed Light',
        ]

        const fontChoices = fonts.map(font => (
            <MenuItem value={font} key={font}>
                <span style={{
                    fontFamily: font,
                    fontWeight: (this.state.labelBold) ? 'bold' : 'normal',
                    fontStyle: (this.state.labelItalic) ? 'italic' : 'normal',
                }}
                >{font}</span>
            </MenuItem>
        ))

        const classificationHTML = this.state.classifications.map(({ label, color, transparent }, i) => {
            // TODO: add border color and size
            const colorStyle = {
                backgroundColor: transparent === true ? 'initial' : color,
            }

            // Render the classification symbol as an icon or a shape
            const getSymbolIMG = (isym) => {
                const sym = this.state.classifications[isym]
                const patternShape = getLayerType(this.props.layerProps.layer_type)
                const url = `${this.props.map.icons.url}${patternShape}/${sym.symbolType || 'Solid'}/${sym.symbol || 'Solid.png'}`
                // If the symbol is not a point, then it will not have an icon.
                if (!sym.symbolType || (sym.symbolType === 'Solid' || patternShape !== 'point')) {
                    return (
                        <div
                            onClick={() => this.openSymHTML(isym)}
                        >
                            <img src={url} alt="sym" style={colorStyle} />
                        </div>
                    )
                }
                return (
                    <div onClick={() => this.openSymHTML(isym)}>
                        <img src={url} alt="sym" />
                    </div>
                )
            }

            return (
                <tr key={label}>
                    <td>
                        <Checkbox
                            checked={this.state.local.editSym.has(i)}
                            onClick={(e) => { this.onCheckClick(e, i) }}
                        />
                    </td>
                    <td className={theme.symTableCellLeft}>
                        {getSymbolIMG(i)}
                    </td>
                    {this.state.local.classifyTypeSaved !== 'Single Symbol' && (
                        <td className={theme.symTableCellCenter}>
                            <TextField
                                inputProps={{
                                    className: theme.tableItem,
                                }}
                                className={theme.tableItem}
                                type="text"
                                defaultValue={label}
                            />
                        </td>
                    )}
                    <td className={theme.symTableCellRight} colSpan="2">
                        <TextField
                            inputProps={{
                                className: theme.tableItem,
                            }}
                            className={theme.tableItem}
                            type="text"
                            defaultValue={label}
                        />
                    </td>
                </tr>
            )
        })

        const fields = Object.keys(this.state.schema.properties)

        const boxPosition = {
            right: this.props.pos.right,
            top: ((this.props.pos.top + this.height < window.innerHeight - 2) ?
                this.props.pos.top : (window.innerHeight - 2 - this.height)),
        }

        const sliderDotStyle = {
            height: '10px',
            width: '10px',
            border: '1px',
        }

        const scales = ['', 10000, 24000, 100000, 200000, 250000, 500000, 750000, 1000000, 3000000, 10000000]
        return (
            <div
                ref={(el) => {
                    this.ref = el
                }}
                className={theme.box}
                style={boxPosition}
                // Prevents drag and drop from blocking input
                //   (https://github.com/atlassian/react-beautiful-dnd#interactive-child-elements-within-a-draggable)
                onMouseDown={e => e.stopPropagation()}
            >
                <AppBar
                    position="static"
                    color="secondary"
                >
                    <Tabs value={itab} onChange={handleChange}>
                        <Tab classes={{ label: theme.tabLabel }} label="General" />
                        <Tab classes={{ label: theme.tabLabel }} label="Symbology" />
                        <Tab classes={{ label: theme.tabLabel }} label="Labels" />
                        <Tab classes={{ label: theme.tabLabel }} label="Metadata" />
                    </Tabs>
                </AppBar>
                <div style={{ display: itab === 0 ? 'block' : 'none' }}>
                    <TabContainer>
                        <table className={theme.layerPropsTable}>
                            <tbody>
                                <tr>
                                    <td colSpan="2">
                                        <div className={theme.paramLabel}>
                                            <span>Opacity&nbsp;</span>
                                            <span ref={c => (this.opacity = c)}>{this.state.opacity}</span>
                                            <span>&nbsp;%</span>
                                        </div>
                                        <Slider
                                            min={0}
                                            max={100}
                                            className={theme.slider}
                                            defaultValue={this.state.opacity}
                                            dotStyle={sliderDotStyle}
                                            handle={handleSliderChange}
                                            onAfterChange={value => changeSlider('opacity', value)}
                                        />
                                    </td>
                                </tr><tr>
                                    <td colSpan="2">
                                        <div className={theme.sectionLabel}>
                                            Zoom Level Display Settings
                                        </div>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Scale Min
                                    </td>
                                    <td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ scaleMin: parseInt(e.target.value || 0) })}
                                            value={this.state.scaleMin}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {scales.filter(s => s === '' || !this.state.scaleMax || s < this.state.scaleMax).map(s => (
                                                <MenuItem key={s} value={s}>{s ? s.toLocaleString() : 'None'}</MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Scale Max
                                    </td>
                                    <td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ scaleMax: parseInt(e.target.value || 0) })}
                                            value={this.state.scaleMax}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {scales.filter(s => !this.state.scaleMin || s > this.state.scaleMin).map(s => (
                                                <MenuItem key={s} value={s}>{s ? s.toLocaleString() : 'None'}</MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr><tr>
                                    <td colSpan="2">
                                        <fieldset className={theme.fieldset}>
                                            <legend className={theme.sectionLabel}>Layer Extent</legend>
                                            <table className={theme.extentTable}>
                                                <tbody>
                                                    <tr>
                                                        <td />
                                                        <td>
                                                            <div className={theme.paramLabel}>Top</div>
                                                            <div>{extents[3]}</div>
                                                        </td>
                                                        <td />
                                                    </tr><tr>
                                                        <td>
                                                            <div className={theme.paramLabel}>Left</div>
                                                            <div>{extents[0]}</div>
                                                        </td>
                                                        <td />
                                                        <td>
                                                            <div className={theme.paramLabel}>Right</div>
                                                            <div>{extents[2]}</div>
                                                        </td>
                                                    </tr><tr>
                                                        <td />
                                                        <td>
                                                            <div className={theme.paramLabel}>Bottom</div>
                                                            <div>{extents[1]}</div>
                                                        </td>
                                                        <td />
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </fieldset>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Identifiable
                                    </td>
                                    <td>
                                        <Switch
                                            checked={this.state.identifiable}
                                            color="secondary"
                                            disabled
                                            onChange={() => this.setState({ identifiable: !this.state.identifiable })}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </TabContainer>
                </div>
                <div style={{ display: itab === 2 ? 'block' : 'none' }}>
                    <TabContainer>
                        <table className={theme.table}>
                            <tbody>
                                <tr>
                                    <td className={theme.paramLabel}>
                                        On
                                    </td><td>
                                        <Switch
                                            checked={this.state.labelsVisible}
                                            color="secondary"
                                            onChange={() => this.setState({ labelsVisible: !this.state.labelsVisible })}
                                            style={{ height: 'initial' }}
                                        />
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Display Field
                                    </td><td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ labelField: e.target.value })}
                                            value={this.state.labelField}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {fields.map(k => (<MenuItem key={k} value={k}>{k}</MenuItem>))}
                                        </Select>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Font
                                    </td><td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ labelFont: e.target.value })}
                                            value={this.state.labelFont}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {fontChoices}
                                        </Select>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Size
                                    </td><td>
                                        <TextField
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ labelSize: e.target.value })}
                                            type="number"
                                            value={this.state.labelSize}
                                            inputProps={{
                                                name: 'Size',
                                                id: 'type-simple',
                                            }}
                                        />
                                    </td>
                                </tr><tr>
                                    <td colSpan="2">
                                        <div className={theme.slider}>
                                            <span>Border Width&nbsp;</span>
                                            <span ref={c => (this.labelBorderWidth = c)}>{this.state.labelBorderWidth}</span>
                                            <span>&nbsp;</span>
                                            <Slider
                                                min={0}
                                                max={100}
                                                className={theme.slider}
                                                defaultValue={this.state.labelBorderWidth}
                                                dotStyle={sliderDotStyle}
                                                handle={handleSliderChange}
                                                onAfterChange={value => changeSlider('labelBorderWidth', value)}
                                            />
                                        </div>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Text Color
                                    </td><td>
                                        <Color
                                            color={this.state.labelTextColor}
                                            onSel={color => this.setState({ labelTextColor: color.hex })}
                                        />
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Background Color
                                    </td><td>
                                        <Color
                                            color={this.state.labelBackgroundColor}
                                            onSel={color => this.setState({ labelBackgroundColor: color.hex })}
                                        />
                                        <span>
                                            <Switch
                                                checked={this.state.labelBackgroundVisible}
                                                style={{ height: 'initial' }}
                                                color="secondary"
                                                onChange={() => this.setState({ labelBackgroundVisible: !this.state.labelBackgroundVisible })}
                                                title="Click off to set transparent"
                                            />
                                        </span>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Border Color
                                    </td><td>
                                        <Color
                                            color={this.state.labelBorderColor}
                                            onSel={color => this.setState({ labelBorderColor: color.hex })}
                                        />
                                    </td>
                                </tr><tr>
                                    <td colSpan="2">
                                        <div className={theme.sectionLabel}>
                                            Label Zoom Display Settings
                                        </div>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Scale Min
                                    </td><td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ labelScaleMin: parseInt(e.target.value || 0) })}
                                            value={this.state.labelScaleMin}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {scales.filter(s => s === '' || !this.state.labelScaleMax || s < this.state.labelScaleMax).map(s => (
                                                <MenuItem key={s} value={s}>{s ? s.toLocaleString() : 'None'}</MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr><tr>
                                    <td className={theme.paramLabel}>
                                        Scale Max
                                    </td><td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({ labelScaleMax: parseInt(e.target.value || 0) })}
                                            value={this.state.labelScaleMax}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            {scales.filter(s => s === '' || !this.state.labelScaleMin || s > this.state.labelScaleMin).map(s => (
                                                <MenuItem key={s} value={s}>{s ? s.toLocaleString() : 'None'}</MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </TabContainer>
                </div>

                {itab === 1 && (
                    <TabContainer className={theme.symbologyTab}>
                        <table className={theme.table}>
                            <tbody>
                                <tr>
                                    <td className={theme.paramLabel}>Classify</td>
                                    <td>
                                        <Select
                                            className={theme.inputStyle}
                                            onChange={e => this.setState({
                                                ...this.state,
                                                classifyType: e.target.value,
                                            })}
                                            value={this.state.classifyType}
                                            inputProps={{
                                                name: 'Type',
                                                id: 'type-simple',
                                            }}
                                        >
                                            <MenuItem value="Single Symbol">Single Symbol</MenuItem>
                                            <MenuItem value="Natural Breaks">Natural Breaks</MenuItem>
                                            <MenuItem value="Equal Distance">Equal Distance</MenuItem>
                                            <MenuItem value="Unique Values">Unique Values</MenuItem>
                                        </Select>
                                    </td>
                                </tr>
                                {this.state.classifyType !== 'Single Symbol' && (
                                    <tr>
                                        <td className={theme.paramLabel}>
                                            Field
                                        </td>
                                        <td>
                                            <Select
                                                className={theme.inputStyle}
                                                onChange={e => this.setState({ classifyField: e.target.value })}
                                                value={this.state.classifyField || fields[0]}
                                                inputProps={{
                                                    name: 'Field',
                                                    id: 'field-simple',
                                                }}
                                            >
                                                {fields.map(k => (<MenuItem key={k} value={k}>{k}</MenuItem>))}
                                            </Select>
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td className={theme.paramLabel}>
                                        Min Color
                                    </td>
                                    <td colSpan="2">
                                        <Color
                                            color={this.state.minColor}
                                            onSel={color => this.setState({ minColor: color.hex })}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={theme.paramLabel}>
                                        Max Color
                                    </td>
                                    <td colSpan="2">
                                        <Color
                                            color={this.state.maxColor}
                                            onSel={color => this.setState({ maxColor: color.hex })}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={theme.paramLabel}>
                                        # of Classes
                                    </td>
                                    <td>
                                        <TextField
                                            className={theme.inputStyle}
                                            type="number"
                                            size="2"
                                            value={this.state.nclass}
                                            onChange={e => this.setState({ nclass: parseInt(e.target.value) || '' })}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={theme.paramLabel}>
                                        Random Colors
                                    </td>
                                    <td>
                                        <Switch
                                            checked={this.state.randomColors}
                                            color="secondary"
                                            onChange={() => this.setState({ randomColors: !this.state.randomColors })}
                                            style={{ height: 'initial' }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" className={theme.generateCell}>
                                        <Button
                                            classes={{
                                                contained: theme.button,
                                            }}
                                            className={theme.generateButton}
                                            color="primary"
                                            onClick={updateClassifications}
                                        >Generate
                                        </Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <table className={theme.symTableHead}>
                                            <thead>
                                                <tr
                                                    className="symtab_content_div dt_no_color noselect"
                                                >
                                                    <th className={theme.labelSpacer}>
                                                        &nbsp;&nbsp;&nbsp;
                                                    </th>
                                                    <th className={theme.symbolLabel}>
                                                        Symbol
                                                    </th>
                                                    {this.state.local.classifyTypeSaved !== 'Single Symbol' && (
                                                        <th
                                                            className={theme.tableLabel}
                                                        >
                                                            {this.state.local.classifyFieldSaved}
                                                        </th>)}
                                                    <th className={theme.tableLabel}>Label</th>
                                                </tr>
                                            </thead>
                                        </table>
                                        <div className={theme.tableContainer}>
                                            <table
                                                className={theme.symTable}
                                            >
                                                <tbody>
                                                    {classificationHTML}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {symHTML}
                    </TabContainer>
                )}

                {itab === 3 && this.renderMetadata()}

                <Button
                    classes={{
                        contained: theme.button,
                    }}
                    className={theme.layerPropsCloseButton}
                    color="primary"
                    onClick={() => this.props.onClose()}
                >Close
                </Button>
                <Button
                    classes={{
                        contained: theme.button,
                    }}
                    className={this.props.theme.layerPropsUpdateButton}
                    color="primary"
                    onClick={this.onChangeProps}
                >Apply
                </Button>

            </div>
        )
    }
}

export default LayerProperties
